module.exports = __webpack_public_path__ + "static/media/pie.2c615510.svg";